<template>
    <div id="app" v-if="userLoaded">
        <Header
            :routes="getUserType"
            :profileRoutes="profileRoutes"
            name="resellers"
        />
        <div class="content">
            <router-view/>
        </div>
        <Footer
            :routes="[
                { name: 'General About Us', label: $translate.text('nav.footer.about') },
                { name: 'General Conditions', label: $translate.text('nav.footer.conditions') },
                { name: 'General faq', label: $translate.text('nav.footer.help') },
                { name: 'General Contact Us', label: $translate.text('nav.footer.contact') }
            ]"
            name="resellers"
            :showLoggedIn="false"
        />
    </div>
</template>
<script>
import { getUserType } from '@/helpers/auth';
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'Resellers',

    components: {
        Header,
        Footer,
    },

    data() {
        return {
            normalRoutes: [
                // { name: 'DashboardContent', label: this.$translate.text('general.dashboard') },
            ],

            adminRoutes: [
                { name: 'Admin Resellers', label: this.$translate.text('general.dashboard') },
                { name: 'Admin Profiles', label: this.$translate.text('general.profiles') },
            ],

            resellerRoutes: [
                { name: 'Resellers Dashboard', label: this.$translate.text('nav.dashboard') },
                { name: 'Resellers Profiles', label: this.$translate.text('nav.profiles') },
            ],

            clientRoutes: [
                { name: 'Clients Dashboard', label: this.$translate.text('general.dashboard') },
                { name: 'Clients Webshops', label: this.$translate.text('general.webshops') },
                { name: 'Clients Feeds', label: this.$translate.text('general.feeds') },
                { name: 'Clients Connections', label: this.$translate.text('general.connections') },
            ],
            profileRoutes: [
                { name: 'Account', label: this.$translate.text('auth.my_account') },
                { name: 'Client Company', label: this.$translate.text('clients.company') },
                { name: 'Logout', label: this.$translate.text('auth.logout') },
            ],

            user: null,
            userLoaded: true,
        };
    },

    methods: {

    },

    computed: {
        getUserType() {
            const userType = getUserType();
            if (userType === null) {
                return this.normalRoutes;
                // eslint-disable-next-line
            } else if (userType === 'client') {
                return this.clientRoutes;
            } else if (userType === 'reseller') {
                return this.resellerRoutes;
            } else if (userType === 'admin') {
                return this.adminRoutes;
            }
            return null;
        },
    },
};
</script>
<style lang="scss" scoped>
    .content {
        min-height: 100%;
        margin-bottom: -50px;
    }
</style>
